import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';
import { useFragment } from 'react-relay/hooks';

import Button, { ButtonProps } from '@material-ui/core/Button';
import { graphql } from 'babel-plugin-relay/macro';
import PopperChatActivityReassign from 'embeds/deprecated/query-triggers/PopperChatActivityReassign';

import { UseReduxMutationConfig } from 'hooks/useReduxMutation';

import { ButtonChatActivityReassign_EmbedChatActivity$key } from './__generated__/ButtonChatActivityReassign_EmbedChatActivity.graphql';

const messages = defineMessages({
  label: {
    id: 'deprecated.fragments.ButtonChatActivityReassign.label',
    defaultMessage: 'Accept and assign',
  },
});

export interface ButtonChatActivityReassignProps extends Omit<ButtonProps, 'classes' | 'onClick'> {
  fragmentRef: ButtonChatActivityReassign_EmbedChatActivity$key;
  mutationConfig?: UseReduxMutationConfig;
}

const ButtonChatActivityReassign: React.FC<ButtonChatActivityReassignProps> = ({
  fragmentRef,
  mutationConfig,
  ...rest
}) => {
  const chatActivity = useFragment<ButtonChatActivityReassign_EmbedChatActivity$key>(
    graphql`
      fragment ButtonChatActivityReassign_EmbedChatActivity on ChatActivity {
        _id
      }
    `,
    fragmentRef,
  );

  const { formatMessage } = useIntl();
  const [anchorEl, setAnchorEl] = useState<(EventTarget & HTMLElement) | null>(null);

  return (
    <>
      <Button onClick={(event) => setAnchorEl(event.currentTarget)} {...rest}>
        {formatMessage(messages.label)}
      </Button>
      {chatActivity && (
        <PopperChatActivityReassign
          chatActivityId={chatActivity._id}
          anchorEl={anchorEl}
          mutationConfig={mutationConfig}
          onClose={() => setAnchorEl(null)}
          onClickAway={() => setAnchorEl(null)}
        />
      )}
    </>
  );
};

export default ButtonChatActivityReassign;
